import { Component, Input, OnInit, Optional, Renderer2, ViewEncapsulation } from '@angular/core';
import { DAO, ProductModel } from 'src/app/modal/DAO';
import { QuestionAnswer, Questionnaire } from 'src/app/modal/questionnaire.models';
import _ from 'lodash';
import { MessageService } from 'primeng/api';
import { ProductService } from 'src/app/services/product.service';
import { Injectable } from "@angular/core";
import { ConfirmationDialogService } from 'src/app/services/confirmationDialog.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ControlContainer, NgModelGroup } from '@angular/forms';

@Injectable({
    providedIn: 'any'
})

@Component({
    selector: 'broadened-pip',
    templateUrl: './broadened-pip.component.html',
    styleUrls: ['./broadened-pip.component.css'],
    encapsulation: ViewEncapsulation.None,
    viewProviders: [{
            provide: ControlContainer,
            deps: [[Optional, NgModelGroup]],
            useFactory: (ngModelGroup: NgModelGroup) => ngModelGroup,
        },]
})
export class BroadenedPIPComponent implements OnInit {

    @Input() questionnaire: Questionnaire;
    @Input() isFormSubmitted: boolean;
    @Input() broadenedPIPDeductibleValue: string;

    public broadenedPIPYesNo: QuestionAnswer;

    public broadenedPIP: QuestionAnswer; //Broadened PIP
    public isBroadenedPipDisabled: boolean = false;

    public broadenedPIPDeductible: QuestionAnswer; //Broadened PIP Deductible
    public isBroadenedPipDeductibleDisabled: boolean = false;

    public nfRateBasis: QuestionAnswer; //Broadened PIP Rating Basis

    public namedIndividualValidationMessage: String;

    public tortLimitSelectionListener?: () => void;
    private destroy$ = new Subject<void>();
    public readonly NAMED_INDIVIDUAL_DELETED: string = "namedIndividualDeleted";
    private accountLegalEntityAnswer: String;

    constructor(private dao: DAO, private messageService: MessageService, private productService: ProductService, private eventRenderer: Renderer2, private confirmationDialogService: ConfirmationDialogService) {

    }

    public ngOnInit(): void {
        this.loadQuestionAnswers();
        this.loadValidationMessage();
        let eventListenerId = document.getElementById("tortLimitSelectYes");
        if (!!eventListenerId) {
            this.tortLimitSelectionListener = this.eventRenderer.listen(eventListenerId,
                this.productService.TORT_LIMIT_SELECTED,
                (event) => {
                    if (!!event.detail && this.questionnaire.questionAnswer.some(x => x.key === 'Q_nfBrd')) {
                        // if the tort limits question is answered as REJECT, then reset the answer of 'broadenedPIPYesNo'
                        if (event.detail == "No") {
                            this.broadenedPIPYesNo.answer = ""
                        }
                        this.broadenedPipSelection();
                    }
                });
        }

        if (this.showBroadenedPIPYesNo) {
            this.broadenedPipSelection();
            this.broadenedPIP.answer = this.broadenedPIP.answer != 'CLICK' ? this.broadenedPIP.answer : this.broadenedPIP?.questionDefault[0]?.code;
        }

        this.confirmationDialogService.confirmationDialogData.pipe(takeUntil(this.destroy$)).subscribe((message: any) => {
            if (message?.data.key == this.NAMED_INDIVIDUAL_DELETED) {
                if (message.response === 'Yes') {
                    this.ProductModel.AddAnotherNamedIndividual[message.data.index].isDeleted = true;
                }
                this.messageService.clear();
                document.body.style.pointerEvents = "visible";
                this.confirmationDialogService.updateDialogData(null);
            }
        });
    }

    /*If "Yes(Accepted)" is selected , show Broaden PIP Yes/No question only.
    If "No(Reject)" is selected:
    -hide broadenPipYesNo question
    -set broadenedPIP answer to default
    -set broadenedPIPDeductible.answer to default, and
    -Clears and resets the named individuals list.*/

    public broadenedPipSelection(): void {
        this.isBroadenedPipDeductibleDisabled = false;
        this.isBroadenedPipDisabled = false;
        if (this.broadenedPIPYesNo.answer == 'Yes') {
            if (this.productService?.productModel?.productDetails?.nfPipDed?.answer) {
                //BroadenedPip Deductible shall have the same answer as that of product.PipDed(No-Fault Deductible)
                this.broadenedPIPDeductible.answer = this.productService.productModel.productDetails.nfPipDed.answer
                this.isBroadenedPipDeductibleDisabled = true;
                this.isBroadenedPipDisabled = true;
            }
        }
        else {
            if (this.broadenedPIP.questionOptions.some(x => x.code == 'CLICK'))
                this.broadenedPIP.answer = 'CLICK';
            this.productService.productModel.AddAnotherNamedIndividual = [];
            this.AddNamedIndividual();
        }
    }

    private loadQuestionAnswers(): void {
        var defaultQuestionAnswer = this.getDefaultQuestionAnswer();

        this.broadenedPIPYesNo = this.LoadAnswerFromDefault('Q_nfBrd') ?? defaultQuestionAnswer;
        this.broadenedPIP = this.LoadAnswerFromDefault('nfBrd') ?? defaultQuestionAnswer;
        this.broadenedPIPDeductible = this.LoadAnswerFromDefault('nfBrdDed') ?? defaultQuestionAnswer;
        this.nfRateBasis = this.LoadAnswerFromDefault('nfRateBasis') || null;
        this.accountLegalEntityAnswer = this.productService.getAccountLegalEntityAnswer();
    }

    public LoadAnswerFromDefault(key: string): QuestionAnswer {
        var defaultQuestionAnswer = this.getDefaultQuestionAnswer();
        let questionAnswer = this.questionnaire.questionAnswer.find(x => x.key === key) ?? defaultQuestionAnswer;
        if (!!!questionAnswer?.answer && questionAnswer?.questionDefault?.length > 0) {
            questionAnswer.answer = questionAnswer.questionDefault[0].code;
        }
        else if (!!!questionAnswer?.answer && questionAnswer?.questionDefault?.length == 0 
              && questionAnswer?.questionOptions[0]?.code.startsWith("CLICK")) 
        {
            questionAnswer.answer = questionAnswer?.questionOptions[0]?.code;
        }
        else if (!!questionAnswer?.answer && questionAnswer?.questionDefault?.length > 0 
                    && !!!questionAnswer?.questionOptions?.some(x => x.code == questionAnswer?.answer))
        {
             questionAnswer.answer = questionAnswer.questionDefault[0].code;
        }
        return questionAnswer;
    }

    private getDefaultQuestionAnswer(): QuestionAnswer {
        return {
            answer: null,
            enabled: false,
            required: false,
            group: null,
            hidden: false,
            key: null,
            isVehicleUpdatedbyVEH1: false,
            minimum: null,
            name: null,
            type: '',
            rowIndex: 0,
            questionOptions: []
        }
    }

    //remove the event listener
    public ngOnDestroy(): void {
        if (this.tortLimitSelectionListener)
            this.tortLimitSelectionListener();

        this.destroy$.next();
        this.destroy$.complete();
    }

    public get showBroadenedPIP(): boolean {
        return this.broadenedPIPYesNo.answer == 'Yes' && this.questionnaire.questionAnswer.some(x => x.key === 'nfBrd');
    }

    public get showBroadenedPIPDeductible(): boolean {
        return this.broadenedPIPYesNo.answer == 'Yes' && this.questionnaire.questionAnswer.some(x => x.key === 'nfBrdDed');
    }

    public removeNamedIndividual(index: number, value: string): void {
        if (value && value != '') {
            let argDetails = {
                "key": this.NAMED_INDIVIDUAL_DELETED,
                "index": index
            }
            document.body.style.pointerEvents = "none";
            this.messageService.add({ key: 'confirmationPopup', sticky: true, severity: 'warn', data: argDetails, summary: ' Do you want to delete ?' });
        }
        else {
            this.ProductModel.AddAnotherNamedIndividual[index].isDeleted = true;
            this.messageService.clear();
            document.body.style.pointerEvents = "visible";
        }
    }

    public get ProductModel(): ProductModel {
        return this.productService.productModel;
    }

    public set ProductModel(productModel: ProductModel) {
        this.productService.productModel = productModel;
    }

    public get getNamedIndividualCount(): boolean {
        return this.ProductModel.AddAnotherNamedIndividual.filter(x => (!x.isDeleted)).length < 3;
    }

    public AddNamedIndividual(): void {
        var nameOfNamedIndividual = { 'Name': "", 'isDeleted': false };
        var tempNamedIndividual = _.cloneDeep(this.ProductModel.AddAnotherNamedIndividual);
        tempNamedIndividual.push(nameOfNamedIndividual);
        this.ProductModel.AddAnotherNamedIndividual = _.cloneDeep(tempNamedIndividual);
    }

    private loadValidationMessage(): void {
        this.namedIndividualValidationMessage = this.productService.getValidationMessage('namedIndividual') ?? "";
    }

    public get showBroadenedPIPYesNo(): boolean {
        let hasTortlimits: boolean = this.questionnaire.questionAnswer.some(x => x.key === 'tortLimits'); // tortLimits is only available to KY state
        if (!hasTortlimits) {
            //other than KY state
            return this.broadenedPIPYesNo.enabled;
        }
        else {
            let tortLimitsQA: QuestionAnswer = this.questionnaire.questionAnswer.find(x => x.key === 'tortLimits');
            if (!tortLimitsQA.questionOptions.some(x => x.label == this.productService.INSURED_AND_ALL_REGULAR_OPERATORS_ACCEPT_TORT_LIMITATION)) {
                // old version
                return this.broadenedPIPYesNo.enabled;
            }
            else {
                // new version
                if (this.accountLegalEntityAnswer != 'INDIVIDUAL') {
                    return false;
                }
                if (this.questionnaire.questionAnswer.find(x => x.key === 'tortLimitSelect').answer == "Yes") {
                    return true;
                }
                return false;
            }
        }
    }
}